import { render, staticRenderFns } from "./role-user-list.vue?vue&type=template&id=335ff1e8&scoped=true&"
import script from "./role-user-list.vue?vue&type=script&lang=js&"
export * from "./role-user-list.vue?vue&type=script&lang=js&"
import style0 from "./role-user-list.vue?vue&type=style&index=0&id=335ff1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ff1e8",
  null
  
)

export default component.exports